import HeaderForForm from '@/components/HeaderForForm';
import StatementForm from '@/components/StatementForm';
import { _prepareErrors } from '@/utils/_function.js';
import * as Api from '@/api';

export default {
  name: 'AddStatement',
  data() {
    return {
      form: {},
      isDataSaving: false,
      isDisabled: false
    };
  },
  components: {
    HeaderForForm,
    StatementForm
  },
  methods: {
    updatingData(value) {
      const { form } = value;
      const data = {
        form
      };

      this.isDataSaving = false;
      Object.assign(this.$data, data);
    },
    closeForm() {
      this.$router.push({ path: '/statements' });
    },
    performFormAction() {
      this.isDataSaving = true;
    },
    savingData() {
      this.isDisabled = true;

      Api.setStatement({ data: this.form })
        .then((response) => {
          if (response) {
            this.$toastr('success', this.$t('form.successAddStatement'));
            this.$router.push({ path: `/statements` });
            this.isDisabled = false;
          }
        })
        .catch((errors) => {
          if (errors) {
            if (errors.data && errors.data.errors && Array.isArray(Object.values(errors.data.errors))) {
              errors.data.errors.forEach((err) => {
                this.$toastr('error', err.detail.errors.domain_is_unique, 'Ошибка');
              });
            }

            _prepareErrors(errors).forEach((err) => {
              this.$toastr('error', err, 'Ошибка');
            });

            this.$rollbar.warning(errors);
          } else {
            this.$toastr('error', this.$t('form.errorAddStatement'), 'Ошибка');
          }

          this.isDisabled = false;
          this.isDataSaving = false;
        });
    }
  }
};
